import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';

import TimeIcon from '@material-ui/icons/AccessTime';
import PlaceIcon from '@material-ui/icons/PlaceOutlined';
import BigIconFieldReadOnly from '../BigIconFieldReadOnly/BigIconFieldReadOnly';

import {
  getString,
  stringToDayName,
  stringToDay,
  stringToMonth,
  stringToYear,
} from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class AppointmentCard extends React.Component {
  render() {
    const {
      classes,
      title,
      description,
      date,
      timeFrom,
      timeTo,
      address,
    } = this.props;

    const stringsComponent = 'appointmentCard';

    return (
      <div className={classes.root}>
        <Card className='Card'>
          <CardHeader
            title={
              <div>
                <Typography variant='h3' className={classes.cardTitle}>
                  {title}
                </Typography>
                <Typography className={classes.subtitle}>
                  {description}
                </Typography>
              </div>
            }
            avatar={
              <div>
                <div className={classes.calendarTop}>
                  <Typography className={classes.dayName}>
                    {stringToDayName(date)}
                  </Typography>
                </div>
                <div className={classes.calendarBottom}>
                  <Typography className={classes.day}>
                    {stringToDay(date)}
                  </Typography>
                  <Typography className={classes.monthYear}>
                    {stringToMonth(date)}
                  </Typography>
                </div>
              </div>
            }
            className='CardHeader'
            classes={{
              root: classes.cardHeader,
              title: `${classes.title} CardHeaderTitle`,
              content: classes.headerContent,
              avatar: `${classes.avatar} CardIcon`,
            }}
          />
          <CardContent
            className='CardContent'
            classes={{
              root: classes.cardContent,
            }}
          >
            <div>
              <Grid
                container
                spacing={24}
                className={`${classes.grid} DashGridContainer`}
              >
                <Grid item xs={12} className='DashGridColumn'>
                  <Divider />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={`${classes.timeContainer} DashGridColumn`}
                >
                  <BigIconFieldReadOnly
                    label={getString(stringsComponent, 'TIME_LABEL')}
                    value={`${timeFrom} - ${timeTo}`}
                    icon={TimeIcon}
                    classes={{
                      icon: classes.fieldIcon,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={`${classes.gridItemDivider} DashGridColumn`}
                >
                  <Divider />
                </Grid>
                <Grid item xs={12} className='DashGridColumn'>
                  <BigIconFieldReadOnly
                    label={getString(stringsComponent, 'LOCATION_LABEL')}
                    value={address}
                    icon={PlaceIcon}
                    classes={{
                      icon: classes.fieldIcon,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

AppointmentCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  timeFrom: PropTypes.string.isRequired,
  timeTo: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};

AppointmentCard.defaultProps = {};

export default withStyles(styles)(AppointmentCard);
